module.exports = __webpack_public_path__ + "static/img/yy2.9029c5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/yy2.png
// module id = 6k4x
// module chunks = 1